<template>
  <el-dialog
      :title="type == 'add' ? '新增uKey授权' : 'uKey授权延期'"
      :visible.sync="visible"
      width="500px"
      v-loading="loading"
      :before-close="handleClose">
    <div>
      <el-form :model="form" ref="ruleForm" :rules="rules">
        <el-form-item label="uKey序列号" label-width="100px" prop="uKeySn">
          <div class="flex">
            <el-input v-model="form.uKeySn" placeholder="请输入uKey序列号" autocomplete="off"
                      :disabled="orgCode !== '91210204341167191F' && type == 'edit'"></el-input>
            <el-button v-if="orgCode === '91210204341167191F'" class="ml10" @click="handleRead">读取</el-button>
          </div>
        </el-form-item>
        <el-form-item label="手机号" label-width="100px" prop="telephone" v-if="type == 'add'">
          <el-input v-model="form.telephone" placeholder="请输入手机号" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleSubmit">确 定</el-button>
      <!--    <el-button type="primary" @click="handleSubmit" v-if="orgCode === '91210204341167191F'">确 定</el-button>-->
      <!--    <el-button class="button-cancel" @click="handleSubmit('wxpay')" v-if="orgCode !== '91210204341167191F'">微信支付</el-button>-->
      <!--    <el-button type="primary" class="button-pay" @click="handleSubmit('alipay')" v-if="orgCode !== '91210204341167191F'">支付宝支付</el-button>-->
  </span>

    <pay-dialog
        v-if="payVisible"
        :visible.sync="payVisible"
        :payList="payList"
        :type="payType"
        @closeAll="closeAll"
    />
  </el-dialog>
</template>

<script>
import {enumDevice} from "@/utils/Ukey";
import Cookie from "js-cookie";
import PayDialog from "@/pages/customerEnterprise/components/ukeyPayDialog.vue";

export default {
  name: "authorizationAdd",
  components: {PayDialog},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    uKeySn: {
      type: String,
      default: ''
    },
  },
  data() {
    const validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        uKeySn: [{required: true, message: "请输入Ukey序列号", trigger: "blur"}],
        telephone: [{required: true, validator: validPhone, trigger: "blur"}],
      },
      form: {},
      loading: false,
      orgCode: '',

      payVisible: false,
      userId: null,
      payList: {},
      payType: '',
    };
  },
  mounted() {
  },
  created() {
    this.$set(this.form, 'uKeySn', this.uKeySn)
    this.orgCode = Cookie.get('orgCode')
  },
  methods: {
    closeAll() {
      this.updateDialog(false)
      this.payVisible = false
      this.$emit('getApplyAuthInfo');
    },
    addApplyAuthInfo(type) {
      this.loading = true
      let params = {
        ...this.form,
        payType: type ? type : null
      }
      this.$http.post(this.$api.customerEnterprise.addApplyAuthInfo, params).then((res) => {
        if (res.data.code == 200) {
          if (this.orgCode !== '91210204341167191F') {
            this.payType = type
            this.payList = {
              ...res.data.data,
              codeImg: "data:image/png;base64," + res.data.data.buyQrcode
            }
            this.payVisible = true
            this.loading = false
          } else {
            this.$message.success(res.data.msg)
            this.closeAll()
            this.loading = false
          }
        } else {
          this.$message.error(res.data.msg);
          this.loading = false
        }
      })
    },
    handleSubmit(type) {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$http.get(this.$api.user.getApplyAuthInfoByUKeySN, {UKeySN: this.form.uKeySn}).then(res => {
            if (res.data.code == 200) {
              this.addApplyAuthInfo(type)
            }
          })
        }
      })
    },
    handleRead() {
      let ukey = enumDevice()
      if (!ukey) {
        this.$message.error('未找到ukey')
      } else {
        this.$set(this.form, 'uKeySn', ukey)
      }
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(() => {
            this.updateDialog(false)
          })
          .catch(() => {
          });
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    },
  }
}
</script>

<style scoped lang="less">

</style>
